import React, { ReactNode } from 'react'
import styleProvider from '@quotatisgroup/uikit-public.style-provider'
import cx from 'classnames'

import './row.scss'

export type RowProps = {
  className?: string
  classes?: string
  children?: ReactNode
  sm?: 'hide' | undefined
  md?: 'hide' | undefined
  columnReverse?: boolean
  hasShadow?: boolean
  noPadding?: boolean
}

export function RowComponent({
  children,
  className,
  classes,
  sm,
  md,
  columnReverse,
  hasShadow = false,
  noPadding,
  ...otherProps
}: RowProps) {
  return (
    <div
      className={cx(
        classes,
        'row',
        {
          [`sm-${sm}`]: sm,
          [`md-${md}`]: md,
          columnReverse,
          blocShadow: hasShadow,
          ['no-padding']: noPadding,
        },
        className,
      )}
      {...otherProps}
    >
      {children}
    </div>
  )
}

export const Row = styleProvider(RowComponent)
